// extracted by mini-css-extract-plugin
module.exports = {"Registration":"Registration_Registration__3t9Zk","container":"Registration_container__55qcA","progressBar":"Registration_progressBar__3SBc4"};